import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { MaterialTabs, SectionSubHeader } from 'components/layout'
import { ActivityProgress } from 'components/misc'
import { ACTIVITY_SECTIONS, ACTIVITY_STATES } from 'constants/enums'
import styles from './rp-sub-header.styl'

export default class RPSubHeader extends Component {
  static propTypes = {
    subtitle: PropTypes.any,
    title: PropTypes.any,
    progressArr: PropTypes.array,
    activityRoute: PropTypes.string,
    rPState: PropTypes.string
  }

  static defaultProps = {
    isMajor: false,
    returnedToParticipant: false
  }

  render() {
    const { title, rPState, subtitle, progressArr, activityRoute } = this.props

    const rPSection = ACTIVITY_SECTIONS.residential_project.id

    const items = [
      { id: 1, intlKey: 'tabs.overview', label: 'Overview', to: 'overview' },
      { id: 2, intlKey: 'tabs.files', label: 'Files', to: 'files' }
    ]

    items.unshift(
      rPState === ACTIVITY_STATES.setup.id
        ? { id: 0, intlKey: 'tabs.new', label: 'New', to: 'new' }
        : { id: 0, intlKey: 'tabs.report', label: 'Report', to: 'report' }
    )

    return (
      <SectionSubHeader
        title={title}
        subtitle={subtitle}
        activitySection={rPSection}
        progress={
          <div className={styles.progressWrap}>
            <div className={styles.progressItem}>
              <ActivityProgress
                activitySection={rPSection}
                completedPercentage={progressArr && progressArr[0] ? 100 : 0}
                white
              />
            </div>
            <div className={`${styles.progressItem} ${styles.progressLast}`}>
              <ActivityProgress
                activitySection={rPSection}
                completedPercentage={progressArr && progressArr[1] ? 100 : 0}
                white
              />
            </div>
          </div>
        }
        tabs={<MaterialTabs root={activityRoute} items={items} />}
      />
    )
  }
}
